import styled from 'styled-components';
import { Spinner } from 'ui/spinner';

const LoaderContainer = styled.div`
  position: absolute;
  inset: 0;
`;

export const TEMPLATE_LOADING_ID = 'template-edit-loader';

export const EditorLoader = () => {
  return (
    <LoaderContainer>
      <Spinner data-test={TEMPLATE_LOADING_ID} />
    </LoaderContainer>
  );
};

export default EditorLoader;
